/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.5 12c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Zm0-1.5C8.3284 10.5 9 9.8284 9 9s-.6716-1.5-1.5-1.5S6 8.1716 6 9s.6716 1.5 1.5 1.5ZM19.5 9c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3ZM18 9c0 .8284-.6716 1.5-1.5 1.5S15 9.8284 15 9s.6716-1.5 1.5-1.5S18 8.1716 18 9Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.5 0C21.9853 0 24 2.0147 24 4.5v16.9516c0 1.5311-2.0242 2.0784-2.7957.7558l-1.152-1.9748A4.5 4.5 0 0 0 16.1653 18H4.5C2.0147 18 0 15.9853 0 13.5v-9C0 2.0147 2.0147 0 4.5 0h15Zm-15 1.5h15c1.6569 0 3 1.3432 3 3v16.9516l-1.152-1.9748A6.0001 6.0001 0 0 0 16.1653 16.5H4.5c-1.6568 0-3-1.3431-3-3v-9c0-1.6568 1.3432-3 3-3Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'Feedback'
);
